import React, { FC, ReactNode } from 'react'

export interface PageContentProps {
    children: ReactNode
}

const PageContent: FC<PageContentProps> = ({ children }) => {
    return (
        <div style={{ padding: '2rem 7rem 2rem 7rem' }}>
            {children}
        </div>
    )
}

export default PageContent 